/**
 * Scroll reveal — fades/rises `[data-scroll-reveal]` sections in once, the first
 * time they scroll into view. Marketing-tier motion, so it is subtle and fires
 * exactly once per section.
 *
 * The hidden state is applied here rather than in CSS, so content stays visible
 * if this script never runs (no-JS or an error). Reduced motion is respected by
 * skipping the effect entirely.
 */

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const designMode = document.documentElement.classList.contains('shopify-design-mode');
const elements = Array.from(document.querySelectorAll('[data-scroll-reveal]'));

if (reduceMotion || designMode || !elements.length || !('IntersectionObserver' in window)) {
  elements.forEach((element) => element.classList.add('is-revealed'));
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        entry.target.classList.add('is-revealed');
        entry.target.classList.remove('scroll-reveal--pending');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0 }
  );

  for (const element of elements) {
    if (element.getBoundingClientRect().top < window.innerHeight) {
      // Already in (or above) the viewport at load — leave visible, no animation.
      element.classList.add('is-revealed');
    } else {
      element.classList.add('scroll-reveal--pending');
      observer.observe(element);
    }
  }
}
